var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetsAllowed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3,
    transform: "matrix(-1 0 0 1 21 1)",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.063 17.255C8.125 5 8.6 4.375 10.625 4.375v2.5l4.31 2.154c.423.212.69.645.69 1.119v.477a2.5 2.5 0 01-2.5 2.5h-1.25v6.062M11.874 16.249l-6.248-3.644"
  }))));
}
export default SvgPetsAllowed;